module.exports = __webpack_public_path__ + "img/SE5164019969.104a6ed7.svg";